import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid2, Typography, Alert } from '@mui/material';
import Checkable from './Checkable';
import { minimumPaymentAmount } from '../../../../../config';

function NetRatePaymentBlock({ onCancel, paymentMethod, onStartTransaction, amount, maxAmount }) {
    const { t } = useTranslation();

    // The commission group's saved company cards ride along with the payment
    // method (getOrdersByReservationId), exactly like the guest's cards do.
    const oldCards = paymentMethod?.methodInfo?.oldCards || [];
    // Effective selection = the agent's pick, else the group's Stripe default
    // card, else the first saved card. Derived, so it tracks the loaded cards.
    const [pickedCard, setPickedCard] = useState(null);
    const selectedCard =
        pickedCard ?? oldCards.find((card) => card.isDefault)?.id ?? oldCards[0]?.id ?? null;

    const payDisabled =
        amount && maxAmount
            ? amount < minimumPaymentAmount ||
              (maxAmount - amount < minimumPaymentAmount && amount !== maxAmount)
            : false;

    return (
        <Grid2 container direction="column" spacing={2}>
            <Grid2 size={{ xs: 12 }}>
                <Typography variant="h6">
                    {paymentMethod.name} {t('paymentmethods.paymentBlock')}
                </Typography>
            </Grid2>
            <Grid2 size={{ xs: 12 }}>
                <Alert severity="info">{t('paymentmethods.netRateCompanyInfo')}</Alert>
            </Grid2>
            {oldCards.length > 0 && (
                <Grid2 size={{ xs: 12 }}>
                    {oldCards.map((card) => (
                        <Checkable
                            key={card.id}
                            attributes={{
                                type: 'radio',
                                name: 'companyCard',
                                value: card.id,
                                checked: selectedCard === card.id,
                                onChange: () => setPickedCard(card.id),
                            }}
                            label={t('widgetReservationInfo.card.oldCard', {
                                cardLast4: card.cardLast4,
                                expMonth: card.expMonth,
                                expYear: card.expYear,
                                cardBrand: card.cardBrand,
                            })}
                        />
                    ))}
                </Grid2>
            )}
            <Grid2 container spacing={2}>
                {onCancel && (
                    <Grid2 size={{ xs: 6 }}>
                        <Button fullWidth onClick={onCancel}>
                            {t('common.cancel')}
                        </Button>
                    </Grid2>
                )}
                <Grid2 size={{ xs: 6 }}>
                    <Button
                        fullWidth
                        onClick={() =>
                            onStartTransaction(
                                selectedCard ? { companyCardPaymentMethodId: selectedCard } : {},
                            )
                        }
                        disabled={payDisabled}
                    >
                        {t('common.pay')}
                    </Button>
                </Grid2>
            </Grid2>
        </Grid2>
    );
}

export default NetRatePaymentBlock;
